// Builds the onConfirm handler of a selector dialog: the picked row (and its id) is put into the header
// and the dialog is closed.
//   dataField: header field that receives the picked row
//   idField:   header field that receives the id of the picked row
export const createSelectorConfirm =
  ({ headerData, setHeaderData, dataField, idField, setShow }) =>
  (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setHeaderData({
        ...headerData,
        [dataField]: selected,
        [idField]: selected.id,
      });
      setShow(false);
    }
    return selected;
  };
